import { render } from "./Loader.vue?vue&type=template&id=980d8730"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=980d8730&lang=css"
script.render = render

export default script